/**
 * New Relic Browser Monitoring for local CRA (`npm start`).
 * Production HTML is instrumented by Django (frontend/views.py) using server
 * env vars, so this module only starts when REACT_APP_NEW_RELIC_* is set.
 */
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

function readConfig() {
	const accountID = (process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID || '').trim();
	const trustKey = (process.env.REACT_APP_NEW_RELIC_TRUST_KEY || accountID).trim();
	const agentID = (process.env.REACT_APP_NEW_RELIC_AGENT_ID || '').trim();
	const licenseKey = (process.env.REACT_APP_NEW_RELIC_LICENSE_KEY || '').trim();
	const applicationID = (process.env.REACT_APP_NEW_RELIC_APPLICATION_ID || '').trim();
	const enabled = (process.env.REACT_APP_NEW_RELIC_BROWSER_ENABLED || 'true').toLowerCase();

	if (enabled === 'false' || enabled === '0' || enabled === 'no') {
		return null;
	}
	if (!accountID || !agentID || !licenseKey || !applicationID) {
		return null;
	}

	const beacon = (process.env.REACT_APP_NEW_RELIC_BEACON || 'bam.nr-data.net').trim();

	return {
		init: {
			browser_consent_mode: { enabled: false },
			privacy: { cookies_enabled: true },
			distributed_tracing: { enabled: true },
			performance: { capture_measures: true },
			ajax: {
				deny_list: [beacon],
				capture_payloads: 'none',
			},
		},
		loader_config: {
			accountID,
			trustKey,
			agentID,
			licenseKey,
			applicationID,
		},
		info: {
			beacon,
			errorBeacon: beacon,
			licenseKey,
			applicationID,
			sa: 1,
		},
	};
}

export function initNewRelicBrowser() {
	const options = readConfig();
	if (!options) {
		return null;
	}
	try {
		return new BrowserAgent(options);
	} catch (err) {
		// Never block app boot if monitoring fails to start.
		console.warn('[newrelic] browser agent failed to start', err);
		return null;
	}
}
